module.exports = __webpack_public_path__ + "img/bg_top.b19501d8.svg";